import {NextRouter} from 'next/router';
import {parse} from 'cookie';

// first check if amplify user id is found in the cookie.
// If not, email is an alias, so check the route for that.
export const getUnauthedDistinctId = (router: NextRouter): string | undefined => {
    const parsedCookied = parse(document.cookie);
    const userId = parsedCookied.amplifyUserUuid;
    return userId || (router.query.email as string);
};
